import React, { useState, useEffect, useCallback } from "react";
import { ChefHat, PackageCheck, Clock, Loader2, Utensils } from "lucide-react";
import * as S from "./styles";
import { toast } from "react-toastify";
import api from "../../api/api";
import OrderCard from "../OrderCard";

const OrderBoard = () => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchOrders = useCallback(async (isSilent = false) => {
    try {
      if (!isSilent) setIsLoading(true);
      const { data } = await api.get("/orders");
      setOrders(data.filter(o => o.status === "pendente" || o.status === "preparando"));
    } catch (error) {
      if (!isSilent) toast.error("Erro ao carregar pedidos");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOrders();
    const interval = setInterval(() => fetchOrders(true), 10000);
    return () => clearInterval(interval);
  }, [fetchOrders]);

  const handleNextStatus = async (id, status) => {
    const next = { pendente: "preparando", preparando: "concluido" }[status];
    try {
      await api.patch(`/orders/${id}`, { status: next });
      
      if (next === "concluido") {
        setOrders(prev => prev.filter(o => o.id !== id));
        toast.success("Pedido finalizado!");
      } else {
        setOrders(prev => prev.map(o => o.id === id ? { ...o, status: next } : o));
        toast.info("Pedido movido para a chapa!");
      }
    } catch {
      toast.error("Falha ao atualizar status");
    }
  };

  const handleCancel = async (id) => {
    if (!window.confirm("Deseja recusar este pedido?")) return;
    try {
      await api.patch(`/orders/${id}`, { status: "cancelado" });
      setOrders(prev => prev.filter(o => o.id !== id));
      toast.warn("Pedido removido.");
    } catch {
      toast.error("Erro ao cancelar");
    }
  };

  if (isLoading) return (
    <S.LoadingWrapper>
      <Loader2 size={40} className="animate-spin" color="#10b981" />
      <p>Carregando Cozinha...</p>
    </S.LoadingWrapper>
  );

  return (
    <S.BoardContainer>
      <S.GlobalHeader>
        <div className="logo-area">
          <ChefHat size={28} color="#10b981" />
          <h1>Painel de Produção</h1>
        </div>
      </S.GlobalHeader>

      <S.ColumnsWrapper>
        <S.Column>
          <S.ColumnHeader color="#10b981">
            <Clock size={18}/> Pendentes ({orders.filter(o => o.status === "pendente").length})
          </S.ColumnHeader>
          <S.OrderList>
            {orders.filter(o => o.status === "pendente").map(o => (
              <OrderCard 
                key={o.id} 
                order={o} 
                onNext={() => handleNextStatus(o.id, "pendente")} 
                onCancel={() => handleCancel(o.id)} 
                label="INICIAR" 
                icon={<ChefHat size={18}/>}
              />
            ))}
          </S.OrderList>
        </S.Column>

        <S.Column>
          <S.ColumnHeader color="#f59e0b">
            <Utensils size={18}/> Na Chapa ({orders.filter(o => o.status === "preparando").length})
          </S.ColumnHeader>
          <S.OrderList>
            {orders.filter(o => o.status === "preparando").map(o => (
              <OrderCard 
                key={o.id} 
                order={o} 
                onNext={() => handleNextStatus(o.id, "preparando")} 
                onCancel={() => handleCancel(o.id)} 
                label="CONCLUIR" 
                icon={<PackageCheck size={18}/>}
              />
            ))}
          </S.OrderList>
        </S.Column>
      </S.ColumnsWrapper>
    </S.BoardContainer>
  );
};

export default OrderBoard;